<template>
    <a-modal
      :title="title"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancelText="$t('antd.table.close')"
      wrapClassName="ant-modal-cust-warp"
      style="top:5%;height: 85%;overflow-y: hidden">
  
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form"  v-bind="layout"  :model="model" :rules="validatorRules">
          <a-form-model-item :label="$t('system.user.userFormItem')" required prop="account">
            <a-input v-model="model.account" :placeholder="$t('system.user.placeholderUserFormItem')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('system.user.passworld')"  prop="password">

            <a-tooltip placement="top">
                <template slot="title">
                <span>{{ passwordTip }}</span>
                </template>
                <a-input v-model="model.password" :placeholder="$t('system.user.placeholderPassworld')"/>
            </a-tooltip>
            </a-form-model-item>

          
          <a-form-model-item :label="$t('system.user.emailFormItem')" prop="email">
            <a-input v-model="model.email" :placeholder="$t('system.user.placeholderEmailFormItem')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('system.user.phoneFormItem')" required prop="phone">
            <a-input v-model="model.phone" :placeholder="$t('system.user.placeholderPhoneFormItem')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('system.user.usernameFormItem')" required prop="username">
            <a-input v-model="model.username" :placeholder="$t('system.user.placeholderUsernameFormItem')"/>
          </a-form-model-item>
          <a-form-model-item :label="$t('system.user.siteNameFormItem')" required prop="siteId">
            <a-select
              v-model="model.siteId"
              show-search
              :placeholder="$t('system.user.placeholderSiteNameFormItem')"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option v-for="(item, index) in selectedItemsAll" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item :label="$t('system.user.roleNameFormItem')" required prop="roleId">
            <a-select
              v-model="model.roleId"
              show-search
              :placeholder="$t('system.user.placeholderRoleNameFormItem')"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option v-for="(item, index) in roleListData" :key="index" :value="item.id">
                {{ item.roleName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
  </template>
  
  <script>
    import {mapGetters } from 'vuex'
    import { userCreate, userUpdate, roleList } from '@/api/app'
    export default {
      name: "CharacterCreate",
      data () {
        return {
          passwordTip:this.$t('system.user.passwordTip'),
          selectedItemsAll:[],
          roleListData:[],
          title:this.$t('antd.table.batch'),
          visible: false,
          roleGroupDisabled:false,
          model: {},
          layout: {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
          },
          confirmLoading: false,
          validatorRules:{
            account: [
              { required: true, message: this.$t('system.user.placeholderUserFormItem') },
            ],
            phone: [
              { required: true, message: this.$t('system.user.placeholderPhoneFormItem')},
            ],
            roleId: [
              { required: true, message: this.$t('system.user.placeholderRoleNameFormItem')},
            ],
            siteId: [
              { required: true, message: this.$t('system.user.placeholderSiteNameFormItem')},
            ],
            username: [
              { required: true, message: this.$t('system.user.placeholderUsernameFormItem')},
            ]
          },
        }
      },
      async created () {
        //备份model原始值
        this.modelDefault = JSON.parse(JSON.stringify(this.model));
        await this.getSelectionGrap()
      },
      mounted(){
         this.selectedItemsAll = this.siteInfo()
      },
      methods: {
        ...mapGetters(["siteInfo"]),
        filterOption(input, option) {
          return (
            option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
          );
        },
        async getSelectionGrap(){
         let res = await roleList()
         if(res.code == '200'){
            this.roleListData = res.data;
          }else{
            this.$message.warning(res.msg);
          }
        },
        add () {
          this.edit({...this.modelDefault });
        },
        edit (record) {
          this.model = Object.assign({}, record);
          this.visible = true;
          //编辑页面禁止修改角色分组
          if(this.model.id){
            this.roleGroupDisabled = true;
          }else{
            this.roleGroupDisabled = false;
          }
        },
        close () {
          this.$refs.form.clearValidate();
          this.$emit('close');
          this.visible = false;
        },
        handleOk () {
          const that = this;
          // 触发表单验证
          this.$refs.form.validate(valid => {
            if (valid) {
              that.confirmLoading = true;
              let obj;
              if(this.model.password){
                this.model.password = window.btoa(this.model.password);
              }
              if(!this.model.id){
                obj=userCreate(this.model);
              }else{
                obj=userUpdate(this.model);
              }
              obj.then((res)=>{
                if(res.code == '200'){
                  that.$message.success(res.msg);
                  that.$emit('ok');
                }else{
                  that.$message.warning(res.msg);
                }
              }).finally(() => {
                that.confirmLoading = false;
                that.close();
              })
            }else{
              return false;
            }
          })
        },
        handleCancel () {
          this.close()
        },
        validateRoleCode(value, callback){
          if(/[\u4E00-\u9FA5]/g.test(value)){
            callback("角色编码不可输入汉字!");
          }else{
            // let params = {
            //   tableName: "sys_role",
            //   fieldName: "role_code",
            //   fieldVal: value,
            //   dataId: this.model.id,
            // };
            // duplicateCheck(params).then((res)=>{
            //   if(res.success){
            //     callback();
            //   }else{
            //     callback(res.message);
            //   }
            // });
          }
        }
      }
    }
  </script>
  
  <style scoped>
  
  </style>